import * as firebase from 'firebase/app';
import 'firebase/firestore';
import 'firebase/auth';
import 'firebase/functions';
import { CLIENTS, DETAILS } from 'utils/constants/collectionNames';
import {
  GET_CLIENT_SUCCEED,
  GET_CLIENT_ERROR,
  DELETE_CLIENT_SUCCEED,
  DELETE_CLIENT_ERROR,
  UPDATE_CLIENT_WORKOUTS_ORDER_SUCCEED,
  UPDATE_CLIENT_WORKOUTS_ORDER_ERROR,
  GET_CLIENT_WORKOUTS_ORDER_SUCCEED,
  GET_CLIENT_WORKOUTS_ORDER_ERROR,
  LOADING_STATE
} from './types';

// get client from Firebase
export const getClient = (clientId, history) => async dispatch => {
  let firestore = firebase.firestore();
  var docRef = firestore.collection(CLIENTS).doc(clientId);

  dispatch({
    type: LOADING_STATE
  });
  docRef
    .get()
    .then(function(doc) {
      if (doc.exists) {
        dispatch({
          type: GET_CLIENT_SUCCEED,
          payload: {
            ...doc.data(),
            id: doc.id
          }
        });
      } else {
        history && history.replace('/event-not-found');
        console.log('No such client!');
      }
    })
    .catch(function(error) {
      console.log(error);
      dispatch({
        type: GET_CLIENT_ERROR,
        payload: `error: ${error}`
      });
      history && history.replace('/event-not-found');
    });
};

export const deleteClient = (clientId, history) => async dispatch => {
  var apiClientsDelete = firebase.functions().httpsCallable('apiClientsDelete');
  apiClientsDelete({ client_id: clientId })
    .then(result => {
      dispatch({ type: DELETE_CLIENT_SUCCEED });
      history.push('/');
    })
    .catch(error => {
      console.error('Error removing document: ', error);
      dispatch({
        type: DELETE_CLIENT_ERROR,
        payload: `error: ${error}`
      });
    });
};

export const updateClientWorkoutsOrder = (
  clientId,
  order
) => async dispatch => {
  let firestore = firebase.firestore();

  firestore
    .collection(CLIENTS)
    .doc(clientId)
    .collection(DETAILS)
    .doc('workout-order')
    .set({
      order: { ...order }
    })
    .then(response => {
      console.log('update is done');
      dispatch({ type: UPDATE_CLIENT_WORKOUTS_ORDER_SUCCEED });
    })
    .catch(error => {
      console.log(error);
      dispatch({
        type: UPDATE_CLIENT_WORKOUTS_ORDER_ERROR,
        payload: `error: ${error}`
      });
    });
};

export const getClientWorkoutsOrder = clientId => async dispatch => {
  let firestore = firebase.firestore();

  firestore
    .collection(CLIENTS)
    .doc(clientId)
    .collection(DETAILS)
    .doc('workout-order')
    .get()
    .then(doc => {
      dispatch({
        type: GET_CLIENT_WORKOUTS_ORDER_SUCCEED,
        payload: doc.data() ? doc.data().order : {}
      });
    })
    .catch(error => {
      console.log(error);
      dispatch({
        type: GET_CLIENT_WORKOUTS_ORDER_ERROR,
        payload: `error: ${error}`
      });
    });
};
